import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { AuthProvider } from './lib/auth.js';
import { GeolocationProvider } from './lib/geolocation.js';
import { registerServiceWorker } from './pwa/registerSW.js';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // In viaggio la rete e' instabile: si mostra il dato in cache e si riprova,
      // senza rifare richieste a ogni cambio di finestra.
      staleTime: 30_000,
      gcTime: 1000 * 60 * 60 * 24,
      refetchOnWindowFocus: false,
      retry: (failureCount) => failureCount < 2,
    },
  },
});

const container = document.getElementById('root');
if (container === null) throw new Error('Elemento #root mancante in index.html');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <GeolocationProvider>
            <App />
          </GeolocationProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);

registerServiceWorker();
